export default __webpack_public_path__ + "static/media/cancel.96fb3ac9.svg";